var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#00AA4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9658 24.9196C45.4735 24.3863 45.4528 23.5423 44.9194 23.0346C44.386 22.5269 43.5421 22.5477 43.0343 23.081L27.5001 39.3998L20.9658 32.5356C20.4581 32.0022 19.6141 31.9814 19.0808 32.4891C18.5474 32.9969 18.5266 33.8408 19.0343 34.3742L26.5343 42.253C26.786 42.5173 27.1351 42.667 27.5001 42.667C27.8651 42.667 28.2142 42.5173 28.4658 42.253L44.9658 24.9196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c90d5dd08552700f5e27067b3ce578ae.svg";
export { ForwardRef as ReactComponent };